<!-- src/common/components/ui/loading-overlay.vue -->
<template>
  <Transition name="fade">
    <div v-if="show || error" class="loading-wrapper">
      <div class="loading-card">
        <!-- Loading state -->
        <template v-if="!error">
          <q-spinner 
            :color="$q.dark.isActive ? 'secondary' : 'primary'" 
            :size="size" 
          />
          <span v-if="text" class="loading-text" v-html="text"/>
        </template>

        <!-- Error state -->
        <template v-else>
          <q-icon name="warning" color="negative" :size="size" />
          <span class="error-text" v-html="errorText"/>
          <q-btn 
            v-if="showRetry"
            :label="$t('Retry')"
            color="primary"
            size="sm"
            outline
            @click="$emit('retry')"
          />
        </template>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useQuasar } from 'quasar'

defineProps({
  show: { type: Boolean, default: false },
  error: { type: Boolean, default: false },
  text: { type: String, default: '' },
  errorText: { type: String, default: 'Something went wrong' },
  size: { type: String, default: '1.25rem' },
  showRetry: { type: Boolean, default: false }
})

defineEmits(['retry'])

const $q = useQuasar()
</script>

<style lang="scss" scoped>
.loading-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-loading, 2000);
  pointer-events: none;
}

.loading-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  backdrop-filter: blur(8px);
  pointer-events: auto;

  body.body--dark & {
    background: rgba(40, 40, 40, 0.95);
  }
}

.loading-text {
  font-size: 0.875rem;
  color: $grey-7;

  body.body--dark & {
    color: $grey-4;
  }
}

.error-text {
  font-size: 0.875rem;
  color: $negative;
}

// Transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>